// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8eb54fde","977":"0250180a"}[chunkId] + ".chunk.js";
};